export default "__VITE_ASSET__aTbnr5C1__"